
import { Component, Prop, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import moment from "moment";
import EarTag from "@/components/shared/EarTag.vue";
import AnimalEventHistory from "@/components/AnimalEventHistory.vue";
import { getTagColour, tagId, visualNumber } from "@/helpers/visual-tag";
import { capitalize } from "@/helpers";
import { withdrawalDaysFromToday } from "@/helpers/withdrawal";

@Component({ components: { EarTag, AnimalEventHistory } })
export default class AnimalData extends Vue {
  @Prop() animal!: Models.Animal;
  withdrawalDays: number | "" = "";
  tab = 0;

  created() {
    if (!this.animal) {
      this.$router.push({ name: "home" });
      return;
    }
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => this.$router.go(-1),
    });
    this.withdrawalDays = this.animal ? withdrawalDaysFromToday(this.animal) ?? "" : "";
  }

  get tagColour() { return getTagColour(this.animal.sgtin); }
  get tagId() { return tagId(this.animal.sgtin); }
  get visualTag() { return visualNumber(this.animal.sgtin); }
  get owner() { return this.animal.owner || this.animal.customFeeder?.name || "N/A"; }
  get gender() { return capitalize(this.animal.gender || ""); }
  get firstProcessedTime() { return this.animal.events[this.animal.events.length - 1]?.time as number; }
  get standingDays() { return this.firstProcessedTime ? moment().diff(moment(this.firstProcessedTime), "days") : "N/A"; }

  get totalAdg() {
    const events = this.processingEvents;
    if (events.length < 2) return "";
    const first = events[events.length - 1];
    const last = events[0];
    if (first.mass === undefined || last.mass === undefined || first.time === undefined || last.time === undefined) return "";
    const days = moment(last.time).diff(moment(first.time), "days");
    return days === 0 ? "" : `${((last.mass - first.mass) / days).toFixed(2)} kg/day`;
  }

  get processingEvents() {
    const events = this.animal.events.filter((event) => event.type.startsWith("processing_"));
    for (let i = 0; i < events.length - 1; i++) {
      const current = events[i];
      const previous = events[i + 1];
      if (current.mass === undefined || previous.mass === undefined || current.time === undefined || previous.time === undefined) {
        current.adg = undefined;
        current.massDiff = undefined;
        continue;
      }
      const days = moment(current.time).diff(moment(previous.time), "days");
      current.massDiff = days === 0 ? undefined : current.mass - previous.mass;
      current.adg = days === 0 ? undefined : (current.mass - previous.mass) / days;
    }
    return events;
  }

  get hospitalEvents() { return this.animal.events.filter((event) => event.type === "hospital"); }
}
